/**
 * Swatch Navigate — Makes pcg-swatch thumbnails on collection cards clickable
 * Builds a mapping of product titles to URLs from all cards on the page.
 * If sibling not found on page, uses Shopify search API to find real URL.
 */
(function() {
  'use strict';

  function buildProductMap() {
    var map = {};
    var cards = document.querySelectorAll('product-card');
    cards.forEach(function(card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var url = link.getAttribute('href').split('?')[0];
      var activeSwatch = card.querySelector('.pcg-swatch--active img');
      if (activeSwatch && activeSwatch.alt) {
        map[activeSwatch.alt.trim().toLowerCase()] = url;
      }
    });
    return map;
  }

  function findProductByTitle(title) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(title) + '&resources[type]=product&resources[limit]=1')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var products = data.resources && data.resources.results && data.resources.results.products;
        if (products && products.length > 0) {
          return products[0].url;
        }
        return null;
      })
      .catch(function() { return null; });
  }

  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.pcg-swatch');
    if (!swatch) return;

    // Don't navigate if it's the active swatch
    if (swatch.classList.contains('pcg-swatch--active')) return;

    // If the swatch carries a direct sibling URL, let the reliable
    // data-swatch-url handler take it (avoids the fragile alt-text map).
    if (swatch.hasAttribute('data-swatch-url')) return;

    var img = swatch.querySelector('img');
    if (!img || !img.alt) return;

    e.preventDefault();
    e.stopPropagation();

    var productMap = buildProductMap();
    var key = img.alt.trim().toLowerCase();
    var url = productMap[key];

    if (url) {
      window.location.href = url;
    } else {
      // Fallback: search for the product using Shopify API
      findProductByTitle(img.alt.trim()).then(function(foundUrl) {
        if (foundUrl) {
          window.location.href = foundUrl;
        }
      });
    }
  }, true);

  /**
   * Generic swatch navigation for cards where each swatch carries its sibling
   * URL directly (data-swatch-url). Used by the Trending (.scg) and Similar
   * Products (.rp) sections where swatches live inside the card link <a>.
   * Intercepts the click in the capture phase so the parent card link does
   * not navigate to the wrong product.
   */
  function handleDirectSwatch(e) {
    var swatch = e.target.closest('[data-swatch-url]');
    if (!swatch) return;
    var url = swatch.getAttribute('data-swatch-url');
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }

  document.addEventListener('click', handleDirectSwatch, true);

  // Keyboard support for role="link" swatches (Enter / Space)
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var swatch = e.target.closest('[data-swatch-url]');
    if (!swatch) return;
    var url = swatch.getAttribute('data-swatch-url');
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }, true);
})();
